import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let studiesSwiperWr = document.querySelectorAll('.studies-swiper-wr');

studiesSwiperWr.forEach((el) => {
  if (!el) return;

  let swiperEl = el.querySelector('.swiper');
  let nextEl = el.querySelector('.swiper-button-next');
  let prevEl = el.querySelector('.swiper-button-prev');
  let paginationEl = el.querySelector('.swiper-pagination');
  let wrapper = swiperEl.querySelector('.swiper-wrapper');

  let slidesCount = swiperEl.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;

  const getDisableState = () => {
    const w = window.innerWidth;
    if (w > 1800 && slidesCount <= 3) return true;
    if (w >= 1024 && w <= 1800 && slidesCount <= 2) return true;
    return false;
  };

  const setDisabledUI = (isDisabled) => {
    if (paginationEl) {
      paginationEl.style.display = isDisabled ? 'none' : '';
    }
    el.classList.toggle('after:content-none', isDisabled);
    el.classList.toggle('before:content-none', isDisabled);
  };

  let disabled = getDisableState();

  let swiper = new Swiper(swiperEl, {
    modules: [Autoplay, Navigation, Pagination],

    observer: true,
    observeParents: true,

    spaceBetween: 12,
    slidesPerView: 1,
    speed: 500,
    threshold: 10,

    allowTouchMove: !disabled,

    navigation: {
      nextEl,
      prevEl,
    },

    pagination: {
      el: paginationEl,
      clickable: true,
    },

    breakpoints: {
      768: { spaceBetween: 16 },
      1024: { spaceBetween: 20 },
      1200: { spaceBetween: 28 },
    },

    autoplay: disabled
        ? false
        : {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: window.innerWidth >= 1033,
        },

    on: {
      afterInit(swiper) {
        const isOverflow = wrapper.scrollWidth > wrapper.clientWidth;
        wrapper.classList.toggle('justify-center', !isOverflow);
        setDisabledUI(disabled);
      },

      resize(swiper) {
        const isOverflow = wrapper.scrollWidth > wrapper.clientWidth;
        wrapper.classList.toggle('justify-center', !isOverflow);

        const shouldDisable = getDisableState();

        if (shouldDisable !== disabled) {
          disabled = shouldDisable;
          swiper.allowTouchMove = !disabled;
          setDisabledUI(disabled);

          if (disabled) {
            swiper.autoplay?.stop();
            swiper.params.autoplay = false;
          } else {
            swiper.params.autoplay = {
              delay: 4000,
              disableOnInteraction: false,
              pauseOnMouseEnter: window.innerWidth >= 1033,
            };
            swiper.autoplay?.start();
          }
        }
      },
    },
  });

  const studyTitlesArr = el.querySelectorAll('.study-card__title');
  lineTitlesFunc(studyTitlesArr);

  if (!disabled) {
    swiperObserver(swiper);
  }
});